<template>
  <div>
    <div
      class="bg-no-repeat bg-contain h-44 mb-2"
      :style="
        'background-image: url(' +
        require('@/assets/images/home/产品首页图片.png') +
        ');'
      "
    >
      <div
        class="grid grid-cols-6 gap-4 h-full flex flex-wrap content-center text-white text-3xl"
      >
        <div class="col-start-2 col-span-4">产品手册下载</div>
      </div>
    </div>
    <div>
      <div
        class="mx-auto mb-3 max-w-sm w-4/5 bg-white border-t-4 border-blue-400 rounded shadow-lg"
      >
        <div class="flex items-center">
          <div class="flex-no-grow px-2 mt-4 mb-2"></div>
          <div class="flex-grow my-4 border-b text-xl">胶枪</div>
          <div class="flex-no-grow px-2 mt-4 mb-2"></div>
        </div>
        <div class="flex items-center" v-for="(video, i) in glue" :key="i">
          <div class="flex-grow px-4 mb-3 flex items-center">
            <div class="flex-no-grow pr-2 flex items-center">
              <img
                class="w-4 h-4"
                src="@/assets/images/home/产品手册下载图标.png"
              />
            </div>
            <div class="flex-grow text-base w-40">{{ video.productName }}</div>
            <div
              class="flex-no-grow flex items-center"
              @click="handleClick(video)"
            >
              <img
                class="w-20"
                src="@/assets/images/home/产品手册下载按钮.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="mx-auto mb-3 max-w-sm w-4/5 bg-white border-t-4 border-blue-400 rounded shadow-lg"
      >
        <div class="flex items-center">
          <div class="flex-no-grow px-2 mt-4 mb-2"></div>
          <div class="flex-grow my-4 border-b text-xl">胶筒/混合管</div>
          <div class="flex-no-grow px-2 mt-4 mb-2"></div>
        </div>
        <div class="flex items-center" v-for="(video, i) in industry" :key="i">
          <div class="flex-grow px-4 mb-3 flex items-center">
            <div class="flex-no-grow pr-2 flex items-center">
              <img
                class="w-4 h-4"
                src="@/assets/images/home/产品手册下载图标.png"
              />
            </div>
            <div class="flex-grow text-base w-40">{{ video.productName }}</div>
            <div
              class="flex-no-grow flex items-center"
              @click="handleClick(video)"
            >
              <img
                class="w-20"
                src="@/assets/images/home/产品手册下载按钮.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="mx-auto mb-3 max-w-sm w-4/5 bg-white border-t-4 border-blue-400 rounded shadow-lg"
      >
        <div class="flex items-center">
          <div class="flex-no-grow px-2 mt-4 mb-2"></div>
          <div class="flex-grow my-4 border-b text-xl">应用</div>
          <div class="flex-no-grow px-2 mt-4 mb-2"></div>
        </div>
        <div
          class="flex items-center"
          v-for="(video, i) in construction"
          :key="i"
        >
          <div class="flex-grow px-4 mb-3 flex items-center">
            <div class="flex-no-grow pr-2 flex items-center">
              <img
                class="w-4 h-4"
                src="@/assets/images/home/产品手册下载图标.png"
              />
            </div>
            <div class="flex-grow text-base w-40">{{ video.productName }}</div>
            <a
              class="flex-no-grow flex items-center"
              @click="handleClick(video)"
            >
              <img
                class="w-20"
                src="@/assets/images/home/产品手册下载按钮.png"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSulzerProductInfoFilePage } from "@/api/index";
export default {
  name: "hello",
  data() {
    return {
      glue: [],
      industry: [],
      construction: [],
    };
  },
  created() {
    this.fetchData("glue");
    this.fetchData("industry");
    this.fetchData("construction");
  },

  methods: {
    handleClick(video) {
      window.location.href = video.fileUrl;
    },
    async fetchData(productType) {
      const { data } = await getSulzerProductInfoFilePage({
        productType: productType,
        page: 1,
        limit: 10000,
      });
      this[productType] = data.data;
    },
  },
};
</script>
<style scoped></style>
